import { render, staticRenderFns } from "./ui-card.vue?vue&type=template&id=db7d3644&scoped=true"
import script from "./ui-card.vue?vue&type=script&lang=js"
export * from "./ui-card.vue?vue&type=script&lang=js"
import style0 from "./ui-card.vue?vue&type=style&index=0&id=db7d3644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7d3644",
  null
  
)

export default component.exports